//This country data was fetched from https://api.worldbank.org/v2/country?format=json&per_page=296 on Feburary 4th 2025 ~ GS

export type WorldBankAPICountry = {
  iso3Code: string;
  iso2Code: string;
  name: string;
  /**
   * Not part of the World Bank API response; added by us.
   * Other names a country is commonly entered as (e.g. "Palestine" for "West Bank and Gaza").
   * `getWorldBankCountryInformation` matches these case-insensitively alongside `name`, `iso3Code` and `iso2Code`.
   * Other code that matches on `name` alone (seeded country choices, country classification) does not check these.
   */
  alternateNames?: string[];
  region: {
    id: string;
    iso2code: string;
    value: string;
  };
  adminregion: {
    id: string;
    iso2code: string;
    value: string;
  };
  incomeLevel: {
    id: string;
    iso2code: string;
    value: string;
  };
  lendingType: {
    id: string;
    iso2code: string;
    value: string;
  };
  capitalCity: string;
  longitude: string;
  latitude: string;
};
export const unitedStatesWorldBankCountry: WorldBankAPICountry = {
  iso3Code: "USA",
  iso2Code: "US",
  name: "United States",
  region: { id: "NAC", iso2code: "XU", value: "North America" },
  adminregion: { id: "", iso2code: "", value: "" },
  incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
  lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
  capitalCity: "Washington D.C.",
  longitude: "-77.032",
  latitude: "38.8895",
};
export const canadaWorldBankCountry: WorldBankAPICountry = {
  iso3Code: "CAN",
  iso2Code: "CA",
  name: "Canada",
  region: { id: "NAC", iso2code: "XU", value: "North America" },
  adminregion: { id: "", iso2code: "", value: "" },
  incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
  lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
  capitalCity: "Ottawa",
  longitude: "-75.6919",
  latitude: "45.4215",
};
export const mexicoWorldBankCountry: WorldBankAPICountry = {
  iso3Code: "MEX",
  iso2Code: "MX",
  name: "Mexico",
  region: {
    id: "LCN",
    iso2code: "ZJ",
    value: "Latin America & Caribbean ",
  },
  adminregion: {
    id: "LAC",
    iso2code: "XJ",
    value: "Latin America & Caribbean (excluding high income)",
  },
  incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
  lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
  capitalCity: "Mexico City",
  longitude: "-99.1276",
  latitude: "19.427",
};
export const worldBankCountryData: WorldBankAPICountry[] = [
  {
    iso3Code: "ABW",
    iso2Code: "AW",
    name: "Aruba",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Oranjestad",
    longitude: "-70.0167",
    latitude: "12.5167",
  },
  {
    iso3Code: "AFE",
    iso2Code: "ZH",
    name: "Africa Eastern and Southern",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "AFG",
    iso2Code: "AF",
    name: "Afghanistan",
    region: { id: "SAS", iso2code: "8S", value: "South Asia" },
    adminregion: { id: "SAS", iso2code: "8S", value: "South Asia" },
    incomeLevel: { id: "LIC", iso2code: "XM", value: "Low income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Kabul",
    longitude: "69.1761",
    latitude: "34.5228",
  },
  {
    iso3Code: "AFR",
    iso2Code: "A9",
    name: "Africa",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "AFW",
    iso2Code: "ZI",
    name: "Africa Western and Central",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "AGO",
    iso2Code: "AO",
    name: "Angola",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Luanda",
    longitude: "13.242",
    latitude: "-8.81155",
  },
  {
    iso3Code: "ALB",
    iso2Code: "AL",
    name: "Albania",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: {
      id: "ECA",
      iso2code: "7E",
      value: "Europe & Central Asia (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Tirane",
    longitude: "19.8172",
    latitude: "41.3317",
  },
  {
    iso3Code: "AND",
    iso2Code: "AD",
    name: "Andorra",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Andorra la Vella",
    longitude: "1.5218",
    latitude: "42.5075",
  },
  {
    iso3Code: "ARB",
    iso2Code: "1A",
    name: "Arab World",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "ARE",
    iso2Code: "AE",
    name: "United Arab Emirates",
    region: {
      id: "MEA",
      iso2code: "ZQ",
      value: "Middle East & North Africa",
    },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Abu Dhabi",
    longitude: "54.3705",
    latitude: "24.4764",
  },
  {
    iso3Code: "ARG",
    iso2Code: "AR",
    name: "Argentina",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: {
      id: "LAC",
      iso2code: "XJ",
      value: "Latin America & Caribbean (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Buenos Aires",
    longitude: "-58.4173",
    latitude: "-34.6118",
  },
  {
    iso3Code: "ARM",
    iso2Code: "AM",
    name: "Armenia",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: {
      id: "ECA",
      iso2code: "7E",
      value: "Europe & Central Asia (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Yerevan",
    longitude: "44.509",
    latitude: "40.1596",
  },
  {
    iso3Code: "ASM",
    iso2Code: "AS",
    name: "American Samoa",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Pago Pago",
    longitude: "-170.691",
    latitude: "-14.2846",
  },
  {
    iso3Code: "ATG",
    iso2Code: "AG",
    name: "Antigua and Barbuda",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Saint John's",
    longitude: "-61.8456",
    latitude: "17.1175",
  },
  {
    iso3Code: "AUS",
    iso2Code: "AU",
    name: "Australia",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Canberra",
    longitude: "149.129",
    latitude: "-35.282",
  },
  {
    iso3Code: "AUT",
    iso2Code: "AT",
    name: "Austria",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Vienna",
    longitude: "16.3798",
    latitude: "48.2201",
  },
  {
    iso3Code: "AZE",
    iso2Code: "AZ",
    name: "Azerbaijan",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: {
      id: "ECA",
      iso2code: "7E",
      value: "Europe & Central Asia (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Baku",
    longitude: "49.8932",
    latitude: "40.3834",
  },
  {
    iso3Code: "BDI",
    iso2Code: "BI",
    name: "Burundi",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LIC", iso2code: "XM", value: "Low income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Bujumbura",
    longitude: "29.3639",
    latitude: "-3.3784",
  },
  {
    iso3Code: "BEA",
    iso2Code: "B4",
    name: "East Asia & Pacific (IBRD-only countries)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "BEC",
    iso2Code: "B7",
    name: "Europe & Central Asia (IBRD-only countries)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "BEL",
    iso2Code: "BE",
    name: "Belgium",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Brussels",
    longitude: "4.36761",
    latitude: "50.8371",
  },
  {
    iso3Code: "BEN",
    iso2Code: "BJ",
    name: "Benin",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Porto-Novo",
    longitude: "2.6323",
    latitude: "6.4779",
  },
  {
    iso3Code: "BFA",
    iso2Code: "BF",
    name: "Burkina Faso",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LIC", iso2code: "XM", value: "Low income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Ouagadougou",
    longitude: "-1.53395",
    latitude: "12.3605",
  },
  {
    iso3Code: "BGD",
    iso2Code: "BD",
    name: "Bangladesh",
    region: { id: "SAS", iso2code: "8S", value: "South Asia" },
    adminregion: { id: "SAS", iso2code: "8S", value: "South Asia" },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Dhaka",
    longitude: "90.4113",
    latitude: "23.7055",
  },
  {
    iso3Code: "BGR",
    iso2Code: "BG",
    name: "Bulgaria",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Sofia",
    longitude: "23.3238",
    latitude: "42.7105",
  },
  {
    iso3Code: "BHI",
    iso2Code: "B1",
    name: "IBRD countries classified as high income",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "BHR",
    iso2Code: "BH",
    name: "Bahrain",
    region: {
      id: "MEA",
      iso2code: "ZQ",
      value: "Middle East & North Africa",
    },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Manama",
    longitude: "50.5354",
    latitude: "26.1921",
  },
  {
    iso3Code: "BHS",
    iso2Code: "BS",
    name: "Bahamas, The",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Nassau",
    longitude: "-77.339",
    latitude: "25.0661",
  },
  {
    iso3Code: "BIH",
    iso2Code: "BA",
    name: "Bosnia and Herzegovina",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: {
      id: "ECA",
      iso2code: "7E",
      value: "Europe & Central Asia (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Sarajevo",
    longitude: "18.4214",
    latitude: "43.8607",
  },
  {
    iso3Code: "BLA",
    iso2Code: "B2",
    name: "Latin America & the Caribbean (IBRD-only countries)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "BLR",
    iso2Code: "BY",
    name: "Belarus",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: {
      id: "ECA",
      iso2code: "7E",
      value: "Europe & Central Asia (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Minsk",
    longitude: "27.5766",
    latitude: "53.9678",
  },
  {
    iso3Code: "BLZ",
    iso2Code: "BZ",
    name: "Belize",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: {
      id: "LAC",
      iso2code: "XJ",
      value: "Latin America & Caribbean (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IDB", iso2code: "XH", value: "Blend" },
    capitalCity: "Belmopan",
    longitude: "-88.7713",
    latitude: "17.2534",
  },
  {
    iso3Code: "BMN",
    iso2Code: "B3",
    name: "Middle East & North Africa (IBRD-only countries)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "BMU",
    iso2Code: "BM",
    name: "Bermuda",
    region: { id: "NAC", iso2code: "XU", value: "North America" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Hamilton",
    longitude: "-64.706",
    latitude: "32.3293",
  },
  {
    iso3Code: "BOL",
    iso2Code: "BO",
    name: "Bolivia",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: {
      id: "LAC",
      iso2code: "XJ",
      value: "Latin America & Caribbean (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "La Paz",
    longitude: "-66.1936",
    latitude: "-13.9908",
  },
  {
    iso3Code: "BRA",
    iso2Code: "BR",
    name: "Brazil",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: {
      id: "LAC",
      iso2code: "XJ",
      value: "Latin America & Caribbean (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Brasilia",
    longitude: "-47.9292",
    latitude: "-15.7801",
  },
  {
    iso3Code: "BRB",
    iso2Code: "BB",
    name: "Barbados",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Bridgetown",
    longitude: "-59.6105",
    latitude: "13.0935",
  },
  {
    iso3Code: "BRN",
    iso2Code: "BN",
    name: "Brunei Darussalam",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Bandar Seri Begawan",
    longitude: "114.946",
    latitude: "4.94199",
  },
  {
    iso3Code: "BSS",
    iso2Code: "B6",
    name: "Sub-Saharan Africa (IBRD-only countries)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "BTN",
    iso2Code: "BT",
    name: "Bhutan",
    region: { id: "SAS", iso2code: "8S", value: "South Asia" },
    adminregion: { id: "SAS", iso2code: "8S", value: "South Asia" },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Thimphu",
    longitude: "89.6177",
    latitude: "27.5768",
  },
  {
    iso3Code: "BWA",
    iso2Code: "BW",
    name: "Botswana",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Gaborone",
    longitude: "25.9201",
    latitude: "-24.6544",
  },
  {
    iso3Code: "CAA",
    iso2Code: "C9",
    name: "Sub-Saharan Africa (IFC classification)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "CAF",
    iso2Code: "CF",
    name: "Central African Republic",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LIC", iso2code: "XM", value: "Low income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Bangui",
    longitude: "21.6407",
    latitude: "5.63056",
  },
  canadaWorldBankCountry,
  {
    iso3Code: "CEA",
    iso2Code: "C4",
    name: "East Asia and the Pacific (IFC classification)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "CEB",
    iso2Code: "B8",
    name: "Central Europe and the Baltics",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "CEU",
    iso2Code: "C5",
    name: "Europe and Central Asia (IFC classification)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "CHE",
    iso2Code: "CH",
    name: "Switzerland",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Bern",
    longitude: "7.44821",
    latitude: "46.948",
  },
  {
    iso3Code: "CHI",
    iso2Code: "JG",
    name: "Channel Islands",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "CHL",
    iso2Code: "CL",
    name: "Chile",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Santiago",
    longitude: "-70.6475",
    latitude: "-33.475",
  },
  {
    iso3Code: "CHN",
    iso2Code: "CN",
    name: "China",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: {
      id: "EAP",
      iso2code: "4E",
      value: "East Asia & Pacific (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Beijing",
    longitude: "116.286",
    latitude: "40.0495",
  },
  {
    iso3Code: "CIV",
    iso2Code: "CI",
    name: "Cote d'Ivoire",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Yamoussoukro",
    longitude: "-4.0305",
    latitude: "5.332",
  },
  {
    iso3Code: "CLA",
    iso2Code: "C6",
    name: "Latin America and the Caribbean (IFC classification)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "CME",
    iso2Code: "C7",
    name: "Middle East and North Africa (IFC classification)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "CMR",
    iso2Code: "CM",
    name: "Cameroon",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDB", iso2code: "XH", value: "Blend" },
    capitalCity: "Yaounde",
    longitude: "11.5174",
    latitude: "3.8721",
  },
  {
    iso3Code: "COD",
    iso2Code: "CD",
    name: "Congo, Dem. Rep.",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LIC", iso2code: "XM", value: "Low income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Kinshasa",
    longitude: "15.3222",
    latitude: "-4.325",
  },
  {
    iso3Code: "COG",
    iso2Code: "CG",
    name: "Congo, Rep.",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDB", iso2code: "XH", value: "Blend" },
    capitalCity: "Brazzaville",
    longitude: "15.2662",
    latitude: "-4.2767",
  },
  {
    iso3Code: "COL",
    iso2Code: "CO",
    name: "Colombia",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: {
      id: "LAC",
      iso2code: "XJ",
      value: "Latin America & Caribbean (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Bogota",
    longitude: "-74.082",
    latitude: "4.60987",
  },
  {
    iso3Code: "COM",
    iso2Code: "KM",
    name: "Comoros",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Moroni",
    longitude: "43.2418",
    latitude: "-11.6986",
  },
  {
    iso3Code: "CPV",
    iso2Code: "CV",
    name: "Cabo Verde",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDB", iso2code: "XH", value: "Blend" },
    capitalCity: "Praia",
    longitude: "-23.5087",
    latitude: "14.9218",
  },
  {
    iso3Code: "CRI",
    iso2Code: "CR",
    name: "Costa Rica",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: {
      id: "LAC",
      iso2code: "XJ",
      value: "Latin America & Caribbean (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "San Jose",
    longitude: "-84.0089",
    latitude: "9.63701",
  },
  {
    iso3Code: "CSA",
    iso2Code: "C8",
    name: "South Asia (IFC classification)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "CSS",
    iso2Code: "S3",
    name: "Caribbean small states",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "CUB",
    iso2Code: "CU",
    name: "Cuba",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: {
      id: "LAC",
      iso2code: "XJ",
      value: "Latin America & Caribbean (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Havana",
    longitude: "-82.3667",
    latitude: "23.1333",
  },
  {
    iso3Code: "CUW",
    iso2Code: "CW",
    name: "Curacao",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Willemstad",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "CYM",
    iso2Code: "KY",
    name: "Cayman Islands",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "George Town",
    longitude: "-81.3857",
    latitude: "19.3022",
  },
  {
    iso3Code: "CYP",
    iso2Code: "CY",
    name: "Cyprus",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Nicosia",
    longitude: "33.3736",
    latitude: "35.1676",
  },
  {
    iso3Code: "CZE",
    iso2Code: "CZ",
    name: "Czechia",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Prague",
    longitude: "14.4205",
    latitude: "50.0878",
  },
  {
    iso3Code: "DEA",
    iso2Code: "D4",
    name: "East Asia & Pacific (IDA-eligible countries)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "DEC",
    iso2Code: "D7",
    name: "Europe & Central Asia (IDA-eligible countries)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "DEU",
    iso2Code: "DE",
    name: "Germany",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Berlin",
    longitude: "13.4115",
    latitude: "52.5235",
  },
  {
    iso3Code: "DJI",
    iso2Code: "DJ",
    name: "Djibouti",
    region: {
      id: "MEA",
      iso2code: "ZQ",
      value: "Middle East & North Africa",
    },
    adminregion: {
      id: "MNA",
      iso2code: "XQ",
      value: "Middle East & North Africa (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Djibouti",
    longitude: "43.1425",
    latitude: "11.5806",
  },
  {
    iso3Code: "DLA",
    iso2Code: "D2",
    name: "Latin America & the Caribbean (IDA-eligible countries)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "DMA",
    iso2Code: "DM",
    name: "Dominica",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: {
      id: "LAC",
      iso2code: "XJ",
      value: "Latin America & Caribbean (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IDB", iso2code: "XH", value: "Blend" },
    capitalCity: "Roseau",
    longitude: "-61.39",
    latitude: "15.2976",
  },
  {
    iso3Code: "DMN",
    iso2Code: "D3",
    name: "Middle East & North Africa (IDA-eligible countries)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "DNK",
    iso2Code: "DK",
    name: "Denmark",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Copenhagen",
    longitude: "12.5681",
    latitude: "55.6763",
  },
  {
    iso3Code: "DNS",
    iso2Code: "N6",
    name: "IDA countries in Sub-Saharan Africa not classified as fragile situations ",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "DOM",
    iso2Code: "DO",
    name: "Dominican Republic",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: {
      id: "LAC",
      iso2code: "XJ",
      value: "Latin America & Caribbean (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Santo Domingo",
    longitude: "-69.8908",
    latitude: "18.479",
  },
  {
    iso3Code: "DSA",
    iso2Code: "D5",
    name: "South Asia (IDA-eligible countries)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "DSF",
    iso2Code: "F6",
    name: "IDA countries in Sub-Saharan Africa classified as fragile situations ",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "DSS",
    iso2Code: "D6",
    name: "Sub-Saharan Africa (IDA-eligible countries)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "DZA",
    iso2Code: "DZ",
    name: "Algeria",
    region: {
      id: "MEA",
      iso2code: "ZQ",
      value: "Middle East & North Africa",
    },
    adminregion: {
      id: "MNA",
      iso2code: "XQ",
      value: "Middle East & North Africa (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Algiers",
    longitude: "3.05097",
    latitude: "36.7397",
  },
  {
    iso3Code: "EAP",
    iso2Code: "4E",
    name: "East Asia & Pacific (excluding high income)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "EAR",
    iso2Code: "V2",
    name: "Early-demographic dividend",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "EAS",
    iso2Code: "Z4",
    name: "East Asia & Pacific",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "ECA",
    iso2Code: "7E",
    name: "Europe & Central Asia (excluding high income)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "ECS",
    iso2Code: "Z7",
    name: "Europe & Central Asia",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "ECU",
    iso2Code: "EC",
    name: "Ecuador",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: {
      id: "LAC",
      iso2code: "XJ",
      value: "Latin America & Caribbean (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Quito",
    longitude: "-78.5243",
    latitude: "-0.229498",
  },
  {
    iso3Code: "EGY",
    iso2Code: "EG",
    name: "Egypt, Arab Rep.",
    region: {
      id: "MEA",
      iso2code: "ZQ",
      value: "Middle East & North Africa",
    },
    adminregion: {
      id: "MNA",
      iso2code: "XQ",
      value: "Middle East & North Africa (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Cairo",
    longitude: "31.2461",
    latitude: "30.0982",
  },
  {
    iso3Code: "EMU",
    iso2Code: "XC",
    name: "Euro area",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "ERI",
    iso2Code: "ER",
    name: "Eritrea",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LIC", iso2code: "XM", value: "Low income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Asmara",
    longitude: "38.9183",
    latitude: "15.3315",
  },
  {
    iso3Code: "ESP",
    iso2Code: "ES",
    name: "Spain",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Madrid",
    longitude: "-3.70327",
    latitude: "40.4167",
  },
  {
    iso3Code: "EST",
    iso2Code: "EE",
    name: "Estonia",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Tallinn",
    longitude: "24.7586",
    latitude: "59.4392",
  },
  {
    iso3Code: "ETH",
    iso2Code: "ET",
    name: "Ethiopia",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LIC", iso2code: "XM", value: "Low income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Addis Ababa",
    longitude: "38.7468",
    latitude: "9.02274",
  },
  {
    iso3Code: "EUU",
    iso2Code: "EU",
    name: "European Union",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "FCS",
    iso2Code: "F1",
    name: "Fragile and conflict affected situations",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "FIN",
    iso2Code: "FI",
    name: "Finland",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Helsinki",
    longitude: "24.9525",
    latitude: "60.1608",
  },
  {
    iso3Code: "FJI",
    iso2Code: "FJ",
    name: "Fiji",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: {
      id: "EAP",
      iso2code: "4E",
      value: "East Asia & Pacific (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IDB", iso2code: "XH", value: "Blend" },
    capitalCity: "Suva",
    longitude: "178.399",
    latitude: "-18.1149",
  },
  {
    iso3Code: "FRA",
    iso2Code: "FR",
    name: "France",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Paris",
    longitude: "2.35097",
    latitude: "48.8566",
  },
  {
    iso3Code: "FRO",
    iso2Code: "FO",
    name: "Faroe Islands",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Torshavn",
    longitude: "-6.91181",
    latitude: "61.8926",
  },
  {
    iso3Code: "FSM",
    iso2Code: "FM",
    name: "Micronesia, Fed. Sts.",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: {
      id: "EAP",
      iso2code: "4E",
      value: "East Asia & Pacific (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Palikir",
    longitude: "158.185",
    latitude: "6.91771",
  },
  {
    iso3Code: "FXS",
    iso2Code: "6F",
    name: "IDA countries classified as fragile situations, excluding Sub-Saharan Africa",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "GAB",
    iso2Code: "GA",
    name: "Gabon",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Libreville",
    longitude: "9.45162",
    latitude: "0.38832",
  },
  {
    iso3Code: "GBR",
    iso2Code: "GB",
    name: "United Kingdom",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "London",
    longitude: "-0.126236",
    latitude: "51.5002",
  },
  {
    iso3Code: "GEO",
    iso2Code: "GE",
    name: "Georgia",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: {
      id: "ECA",
      iso2code: "7E",
      value: "Europe & Central Asia (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Tbilisi",
    longitude: "44.793",
    latitude: "41.71",
  },
  {
    iso3Code: "GHA",
    iso2Code: "GH",
    name: "Ghana",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Accra",
    longitude: "-0.20795",
    latitude: "5.57045",
  },
  {
    iso3Code: "GIB",
    iso2Code: "GI",
    name: "Gibraltar",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "GIN",
    iso2Code: "GN",
    name: "Guinea",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Conakry",
    longitude: "-13.7",
    latitude: "9.51667",
  },
  {
    iso3Code: "GMB",
    iso2Code: "GM",
    name: "Gambia, The",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LIC", iso2code: "XM", value: "Low income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Banjul",
    longitude: "-16.5885",
    latitude: "13.4495",
  },
  {
    iso3Code: "GNB",
    iso2Code: "GW",
    name: "Guinea-Bissau",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LIC", iso2code: "XM", value: "Low income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Bissau",
    longitude: "-15.1804",
    latitude: "11.8037",
  },
  {
    iso3Code: "GNQ",
    iso2Code: "GQ",
    name: "Equatorial Guinea",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Malabo",
    longitude: "8.7741",
    latitude: "3.7523",
  },
  {
    iso3Code: "GRC",
    iso2Code: "GR",
    name: "Greece",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Athens",
    longitude: "23.7166",
    latitude: "37.9792",
  },
  {
    iso3Code: "GRD",
    iso2Code: "GD",
    name: "Grenada",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: {
      id: "LAC",
      iso2code: "XJ",
      value: "Latin America & Caribbean (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IDB", iso2code: "XH", value: "Blend" },
    capitalCity: "Saint George's",
    longitude: "-61.7449",
    latitude: "12.0653",
  },
  {
    iso3Code: "GRL",
    iso2Code: "GL",
    name: "Greenland",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Nuuk",
    longitude: "-51.7214",
    latitude: "64.1836",
  },
  {
    iso3Code: "GTM",
    iso2Code: "GT",
    name: "Guatemala",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: {
      id: "LAC",
      iso2code: "XJ",
      value: "Latin America & Caribbean (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Guatemala City",
    longitude: "-90.5328",
    latitude: "14.6248",
  },
  {
    iso3Code: "GUM",
    iso2Code: "GU",
    name: "Guam",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Agana",
    longitude: "144.794",
    latitude: "13.4443",
  },
  {
    iso3Code: "GUY",
    iso2Code: "GY",
    name: "Guyana",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Georgetown",
    longitude: "-58.1548",
    latitude: "6.80461",
  },
  {
    iso3Code: "HIC",
    iso2Code: "XD",
    name: "High income",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "HKG",
    iso2Code: "HK",
    name: "Hong Kong SAR, China",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "",
    longitude: "114.109",
    latitude: "22.3964",
  },
  {
    iso3Code: "HND",
    iso2Code: "HN",
    name: "Honduras",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: {
      id: "LAC",
      iso2code: "XJ",
      value: "Latin America & Caribbean (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Tegucigalpa",
    longitude: "-87.4667",
    latitude: "15.1333",
  },
  {
    iso3Code: "HPC",
    iso2Code: "XE",
    name: "Heavily indebted poor countries (HIPC)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "HRV",
    iso2Code: "HR",
    name: "Croatia",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Zagreb",
    longitude: "15.9614",
    latitude: "45.8069",
  },
  {
    iso3Code: "HTI",
    iso2Code: "HT",
    name: "Haiti",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: {
      id: "LAC",
      iso2code: "XJ",
      value: "Latin America & Caribbean (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Port-au-Prince",
    longitude: "-72.3288",
    latitude: "18.5392",
  },
  {
    iso3Code: "HUN",
    iso2Code: "HU",
    name: "Hungary",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Budapest",
    longitude: "19.0408",
    latitude: "47.4984",
  },
  {
    iso3Code: "IBB",
    iso2Code: "ZB",
    name: "IBRD, including blend",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "IBD",
    iso2Code: "XF",
    name: "IBRD only",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "IBT",
    iso2Code: "ZT",
    name: "IDA & IBRD total",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "IDA",
    iso2Code: "XG",
    name: "IDA total",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "IDB",
    iso2Code: "XH",
    name: "IDA blend",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "IDN",
    iso2Code: "ID",
    name: "Indonesia",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: {
      id: "EAP",
      iso2code: "4E",
      value: "East Asia & Pacific (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Jakarta",
    longitude: "106.83",
    latitude: "-6.19752",
  },
  {
    iso3Code: "IDX",
    iso2Code: "XI",
    name: "IDA only",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "IMN",
    iso2Code: "IM",
    name: "Isle of Man",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Douglas",
    longitude: "-4.47928",
    latitude: "54.1509",
  },
  {
    iso3Code: "IND",
    iso2Code: "IN",
    name: "India",
    region: { id: "SAS", iso2code: "8S", value: "South Asia" },
    adminregion: { id: "SAS", iso2code: "8S", value: "South Asia" },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "New Delhi",
    longitude: "77.225",
    latitude: "28.6353",
  },
  {
    iso3Code: "INX",
    iso2Code: "XY",
    name: "Not classified",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "IRL",
    iso2Code: "IE",
    name: "Ireland",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Dublin",
    longitude: "-6.26749",
    latitude: "53.3441",
  },
  {
    iso3Code: "IRN",
    iso2Code: "IR",
    name: "Iran, Islamic Rep.",
    region: {
      id: "MEA",
      iso2code: "ZQ",
      value: "Middle East & North Africa",
    },
    adminregion: {
      id: "MNA",
      iso2code: "XQ",
      value: "Middle East & North Africa (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Tehran",
    longitude: "51.4447",
    latitude: "35.6878",
  },
  {
    iso3Code: "IRQ",
    iso2Code: "IQ",
    name: "Iraq",
    region: {
      id: "MEA",
      iso2code: "ZQ",
      value: "Middle East & North Africa",
    },
    adminregion: {
      id: "MNA",
      iso2code: "XQ",
      value: "Middle East & North Africa (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Baghdad",
    longitude: "44.394",
    latitude: "33.3302",
  },
  {
    iso3Code: "ISL",
    iso2Code: "IS",
    name: "Iceland",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Reykjavik",
    longitude: "-21.8952",
    latitude: "64.1353",
  },
  {
    iso3Code: "ISR",
    iso2Code: "IL",
    name: "Israel",
    region: {
      id: "MEA",
      iso2code: "ZQ",
      value: "Middle East & North Africa",
    },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "",
    longitude: "35.2035",
    latitude: "31.7717",
  },
  {
    iso3Code: "ITA",
    iso2Code: "IT",
    name: "Italy",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Rome",
    longitude: "12.4823",
    latitude: "41.8955",
  },
  {
    iso3Code: "JAM",
    iso2Code: "JM",
    name: "Jamaica",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: {
      id: "LAC",
      iso2code: "XJ",
      value: "Latin America & Caribbean (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Kingston",
    longitude: "-76.792",
    latitude: "17.9927",
  },
  {
    iso3Code: "JOR",
    iso2Code: "JO",
    name: "Jordan",
    region: {
      id: "MEA",
      iso2code: "ZQ",
      value: "Middle East & North Africa",
    },
    adminregion: {
      id: "MNA",
      iso2code: "XQ",
      value: "Middle East & North Africa (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Amman",
    longitude: "35.9263",
    latitude: "31.9497",
  },
  {
    iso3Code: "JPN",
    iso2Code: "JP",
    name: "Japan",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Tokyo",
    longitude: "139.77",
    latitude: "35.67",
  },
  {
    iso3Code: "KAZ",
    iso2Code: "KZ",
    name: "Kazakhstan",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: {
      id: "ECA",
      iso2code: "7E",
      value: "Europe & Central Asia (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Astana",
    longitude: "71.4382",
    latitude: "51.1879",
  },
  {
    iso3Code: "KEN",
    iso2Code: "KE",
    name: "Kenya",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDB", iso2code: "XH", value: "Blend" },
    capitalCity: "Nairobi",
    longitude: "36.8126",
    latitude: "-1.27975",
  },
  {
    iso3Code: "KGZ",
    iso2Code: "KG",
    name: "Kyrgyz Republic",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: {
      id: "ECA",
      iso2code: "7E",
      value: "Europe & Central Asia (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Bishkek",
    longitude: "74.6057",
    latitude: "42.8851",
  },
  {
    iso3Code: "KHM",
    iso2Code: "KH",
    name: "Cambodia",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: {
      id: "EAP",
      iso2code: "4E",
      value: "East Asia & Pacific (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Phnom Penh",
    longitude: "104.874",
    latitude: "11.5556",
  },
  {
    iso3Code: "KIR",
    iso2Code: "KI",
    name: "Kiribati",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: {
      id: "EAP",
      iso2code: "4E",
      value: "East Asia & Pacific (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Tarawa",
    longitude: "172.979",
    latitude: "1.32905",
  },
  {
    iso3Code: "KNA",
    iso2Code: "KN",
    name: "St. Kitts and Nevis",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Basseterre",
    longitude: "-62.7309",
    latitude: "17.3",
  },
  {
    iso3Code: "KOR",
    iso2Code: "KR",
    name: "Korea, Rep.",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Seoul",
    longitude: "126.957",
    latitude: "37.5323",
  },
  {
    iso3Code: "KWT",
    iso2Code: "KW",
    name: "Kuwait",
    region: {
      id: "MEA",
      iso2code: "ZQ",
      value: "Middle East & North Africa",
    },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Kuwait City",
    longitude: "47.9824",
    latitude: "29.3721",
  },
  {
    iso3Code: "LAC",
    iso2Code: "XJ",
    name: "Latin America & Caribbean (excluding high income)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "LAO",
    iso2Code: "LA",
    name: "Lao PDR",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: {
      id: "EAP",
      iso2code: "4E",
      value: "East Asia & Pacific (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Vientiane",
    longitude: "102.177",
    latitude: "18.5826",
  },
  {
    iso3Code: "LBN",
    iso2Code: "LB",
    name: "Lebanon",
    region: {
      id: "MEA",
      iso2code: "ZQ",
      value: "Middle East & North Africa",
    },
    adminregion: {
      id: "MNA",
      iso2code: "XQ",
      value: "Middle East & North Africa (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Beirut",
    longitude: "35.5134",
    latitude: "33.8872",
  },
  {
    iso3Code: "LBR",
    iso2Code: "LR",
    name: "Liberia",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LIC", iso2code: "XM", value: "Low income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Monrovia",
    longitude: "-10.7957",
    latitude: "6.30039",
  },
  {
    iso3Code: "LBY",
    iso2Code: "LY",
    name: "Libya",
    region: {
      id: "MEA",
      iso2code: "ZQ",
      value: "Middle East & North Africa",
    },
    adminregion: {
      id: "MNA",
      iso2code: "XQ",
      value: "Middle East & North Africa (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Tripoli",
    longitude: "13.1072",
    latitude: "32.8578",
  },
  {
    iso3Code: "LCA",
    iso2Code: "LC",
    name: "St. Lucia",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: {
      id: "LAC",
      iso2code: "XJ",
      value: "Latin America & Caribbean (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IDB", iso2code: "XH", value: "Blend" },
    capitalCity: "Castries",
    longitude: "-60.9832",
    latitude: "14",
  },
  {
    iso3Code: "LCN",
    iso2Code: "ZJ",
    name: "Latin America & Caribbean ",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "LDC",
    iso2Code: "XL",
    name: "Least developed countries: UN classification",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "LIC",
    iso2Code: "XM",
    name: "Low income",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "LIE",
    iso2Code: "LI",
    name: "Liechtenstein",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Vaduz",
    longitude: "9.52148",
    latitude: "47.1411",
  },
  {
    iso3Code: "LKA",
    iso2Code: "LK",
    name: "Sri Lanka",
    region: { id: "SAS", iso2code: "8S", value: "South Asia" },
    adminregion: { id: "SAS", iso2code: "8S", value: "South Asia" },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Colombo",
    longitude: "79.8528",
    latitude: "6.92148",
  },
  {
    iso3Code: "LMC",
    iso2Code: "XN",
    name: "Lower middle income",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "LMY",
    iso2Code: "XO",
    name: "Low & middle income",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "LSO",
    iso2Code: "LS",
    name: "Lesotho",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Maseru",
    longitude: "27.7167",
    latitude: "-29.5208",
  },
  {
    iso3Code: "LTE",
    iso2Code: "V3",
    name: "Late-demographic dividend",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "LTU",
    iso2Code: "LT",
    name: "Lithuania",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Vilnius",
    longitude: "25.2799",
    latitude: "54.6896",
  },
  {
    iso3Code: "LUX",
    iso2Code: "LU",
    name: "Luxembourg",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Luxembourg",
    longitude: "6.1296",
    latitude: "49.61",
  },
  {
    iso3Code: "LVA",
    iso2Code: "LV",
    name: "Latvia",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Riga",
    longitude: "24.1048",
    latitude: "56.9465",
  },
  {
    iso3Code: "MAC",
    iso2Code: "MO",
    name: "Macao SAR, China",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "",
    longitude: "113.55",
    latitude: "22.1667",
  },
  {
    iso3Code: "MAF",
    iso2Code: "MF",
    name: "St. Martin (French part)",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Marigot",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "MAR",
    iso2Code: "MA",
    name: "Morocco",
    region: {
      id: "MEA",
      iso2code: "ZQ",
      value: "Middle East & North Africa",
    },
    adminregion: {
      id: "MNA",
      iso2code: "XQ",
      value: "Middle East & North Africa (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Rabat",
    longitude: "-6.8704",
    latitude: "33.9905",
  },
  {
    iso3Code: "MCO",
    iso2Code: "MC",
    name: "Monaco",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Monaco",
    longitude: "7.41891",
    latitude: "43.7325",
  },
  {
    iso3Code: "MDA",
    iso2Code: "MD",
    name: "Moldova",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: {
      id: "ECA",
      iso2code: "7E",
      value: "Europe & Central Asia (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Chisinau",
    longitude: "28.8497",
    latitude: "47.0167",
  },
  {
    iso3Code: "MDE",
    iso2Code: "M1",
    name: "Middle East (developing only)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "MDG",
    iso2Code: "MG",
    name: "Madagascar",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LIC", iso2code: "XM", value: "Low income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Antananarivo",
    longitude: "45.7167",
    latitude: "-20.4667",
  },
  {
    iso3Code: "MDV",
    iso2Code: "MV",
    name: "Maldives",
    region: { id: "SAS", iso2code: "8S", value: "South Asia" },
    adminregion: { id: "SAS", iso2code: "8S", value: "South Asia" },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Male",
    longitude: "73.5109",
    latitude: "4.1742",
  },
  {
    iso3Code: "MEA",
    iso2Code: "ZQ",
    name: "Middle East & North Africa",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  mexicoWorldBankCountry,
  {
    iso3Code: "MHL",
    iso2Code: "MH",
    name: "Marshall Islands",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: {
      id: "EAP",
      iso2code: "4E",
      value: "East Asia & Pacific (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Majuro",
    longitude: "171.135",
    latitude: "7.11046",
  },
  {
    iso3Code: "MIC",
    iso2Code: "XP",
    name: "Middle income",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "MKD",
    iso2Code: "MK",
    name: "North Macedonia",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: {
      id: "ECA",
      iso2code: "7E",
      value: "Europe & Central Asia (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Skopje",
    longitude: "21.4361",
    latitude: "42.0024",
  },
  {
    iso3Code: "MLI",
    iso2Code: "ML",
    name: "Mali",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LIC", iso2code: "XM", value: "Low income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Bamako",
    longitude: "-7.50034",
    latitude: "13.5667",
  },
  {
    iso3Code: "MLT",
    iso2Code: "MT",
    name: "Malta",
    region: {
      id: "MEA",
      iso2code: "ZQ",
      value: "Middle East & North Africa",
    },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Valletta",
    longitude: "14.5189",
    latitude: "35.9042",
  },
  {
    iso3Code: "MMR",
    iso2Code: "MM",
    name: "Myanmar",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: {
      id: "EAP",
      iso2code: "4E",
      value: "East Asia & Pacific (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Naypyidaw",
    longitude: "95.9562",
    latitude: "21.914",
  },
  {
    iso3Code: "MNA",
    iso2Code: "XQ",
    name: "Middle East & North Africa (excluding high income)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "MNE",
    iso2Code: "ME",
    name: "Montenegro",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: {
      id: "ECA",
      iso2code: "7E",
      value: "Europe & Central Asia (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Podgorica",
    longitude: "19.2595",
    latitude: "42.4602",
  },
  {
    iso3Code: "MNG",
    iso2Code: "MN",
    name: "Mongolia",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: {
      id: "EAP",
      iso2code: "4E",
      value: "East Asia & Pacific (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Ulaanbaatar",
    longitude: "106.937",
    latitude: "47.9129",
  },
  {
    iso3Code: "MNP",
    iso2Code: "MP",
    name: "Northern Mariana Islands",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Saipan",
    longitude: "145.765",
    latitude: "15.1935",
  },
  {
    iso3Code: "MOZ",
    iso2Code: "MZ",
    name: "Mozambique",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LIC", iso2code: "XM", value: "Low income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Maputo",
    longitude: "32.5713",
    latitude: "-25.9664",
  },
  {
    iso3Code: "MRT",
    iso2Code: "MR",
    name: "Mauritania",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Nouakchott",
    longitude: "-15.9824",
    latitude: "18.2367",
  },
  {
    iso3Code: "MUS",
    iso2Code: "MU",
    name: "Mauritius",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Port Louis",
    longitude: "57.4977",
    latitude: "-20.1605",
  },
  {
    iso3Code: "MWI",
    iso2Code: "MW",
    name: "Malawi",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LIC", iso2code: "XM", value: "Low income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Lilongwe",
    longitude: "33.7703",
    latitude: "-13.9899",
  },
  {
    iso3Code: "MYS",
    iso2Code: "MY",
    name: "Malaysia",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: {
      id: "EAP",
      iso2code: "4E",
      value: "East Asia & Pacific (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Kuala Lumpur",
    longitude: "101.684",
    latitude: "3.12433",
  },
  {
    iso3Code: "NAC",
    iso2Code: "XU",
    name: "North America",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "NAF",
    iso2Code: "M2",
    name: "North Africa",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "NAM",
    iso2Code: "NA",
    name: "Namibia",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Windhoek",
    longitude: "17.0931",
    latitude: "-22.5648",
  },
  {
    iso3Code: "NCL",
    iso2Code: "NC",
    name: "New Caledonia",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Noum'ea",
    longitude: "166.464",
    latitude: "-22.2677",
  },
  {
    iso3Code: "NER",
    iso2Code: "NE",
    name: "Niger",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LIC", iso2code: "XM", value: "Low income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Niamey",
    longitude: "2.1073",
    latitude: "13.514",
  },
  {
    iso3Code: "NGA",
    iso2Code: "NG",
    name: "Nigeria",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDB", iso2code: "XH", value: "Blend" },
    capitalCity: "Abuja",
    longitude: "7.48906",
    latitude: "9.05804",
  },
  {
    iso3Code: "NIC",
    iso2Code: "NI",
    name: "Nicaragua",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: {
      id: "LAC",
      iso2code: "XJ",
      value: "Latin America & Caribbean (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Managua",
    longitude: "-86.2734",
    latitude: "12.1475",
  },
  {
    iso3Code: "NLD",
    iso2Code: "NL",
    name: "Netherlands",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Amsterdam",
    longitude: "4.89095",
    latitude: "52.3738",
  },
  {
    iso3Code: "NOR",
    iso2Code: "NO",
    name: "Norway",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Oslo",
    longitude: "10.7387",
    latitude: "59.9138",
  },
  {
    iso3Code: "NPL",
    iso2Code: "NP",
    name: "Nepal",
    region: { id: "SAS", iso2code: "8S", value: "South Asia" },
    adminregion: { id: "SAS", iso2code: "8S", value: "South Asia" },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Kathmandu",
    longitude: "85.3157",
    latitude: "27.6939",
  },
  {
    iso3Code: "NRS",
    iso2Code: "6X",
    name: "Non-resource rich Sub-Saharan Africa countries",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "NRU",
    iso2Code: "NR",
    name: "Nauru",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Yaren District",
    longitude: "166.920867",
    latitude: "-0.5477",
  },
  {
    iso3Code: "NXS",
    iso2Code: "6N",
    name: "IDA countries not classified as fragile situations, excluding Sub-Saharan Africa",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "NZL",
    iso2Code: "NZ",
    name: "New Zealand",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Wellington",
    longitude: "174.776",
    latitude: "-41.2865",
  },
  {
    iso3Code: "OED",
    iso2Code: "OE",
    name: "OECD members",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "OMN",
    iso2Code: "OM",
    name: "Oman",
    region: {
      id: "MEA",
      iso2code: "ZQ",
      value: "Middle East & North Africa",
    },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Muscat",
    longitude: "58.5874",
    latitude: "23.6105",
  },
  {
    iso3Code: "OSS",
    iso2Code: "S4",
    name: "Other small states",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "PAK",
    iso2Code: "PK",
    name: "Pakistan",
    region: { id: "SAS", iso2code: "8S", value: "South Asia" },
    adminregion: { id: "SAS", iso2code: "8S", value: "South Asia" },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDB", iso2code: "XH", value: "Blend" },
    capitalCity: "Islamabad",
    longitude: "72.8",
    latitude: "30.5167",
  },
  {
    iso3Code: "PAN",
    iso2Code: "PA",
    name: "Panama",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Panama City",
    longitude: "-79.5188",
    latitude: "8.99427",
  },
  {
    iso3Code: "PER",
    iso2Code: "PE",
    name: "Peru",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: {
      id: "LAC",
      iso2code: "XJ",
      value: "Latin America & Caribbean (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Lima",
    longitude: "-77.0465",
    latitude: "-12.0931",
  },
  {
    iso3Code: "PHL",
    iso2Code: "PH",
    name: "Philippines",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: {
      id: "EAP",
      iso2code: "4E",
      value: "East Asia & Pacific (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Manila",
    longitude: "121.035",
    latitude: "14.5515",
  },
  {
    iso3Code: "PLW",
    iso2Code: "PW",
    name: "Palau",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Koror",
    longitude: "134.479",
    latitude: "7.34194",
  },
  {
    iso3Code: "PNG",
    iso2Code: "PG",
    name: "Papua New Guinea",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: {
      id: "EAP",
      iso2code: "4E",
      value: "East Asia & Pacific (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDB", iso2code: "XH", value: "Blend" },
    capitalCity: "Port Moresby",
    longitude: "147.194",
    latitude: "-9.47357",
  },
  {
    iso3Code: "POL",
    iso2Code: "PL",
    name: "Poland",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Warsaw",
    longitude: "21.02",
    latitude: "52.26",
  },
  {
    iso3Code: "PRE",
    iso2Code: "V1",
    name: "Pre-demographic dividend",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "PRI",
    iso2Code: "PR",
    name: "Puerto Rico",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "San Juan",
    longitude: "-66",
    latitude: "18.23",
  },
  {
    iso3Code: "PRK",
    iso2Code: "KP",
    name: "Korea, Dem. People's Rep.",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: {
      id: "EAP",
      iso2code: "4E",
      value: "East Asia & Pacific (excluding high income)",
    },
    incomeLevel: { id: "LIC", iso2code: "XM", value: "Low income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Pyongyang",
    longitude: "125.754",
    latitude: "39.0319",
  },
  {
    iso3Code: "PRT",
    iso2Code: "PT",
    name: "Portugal",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Lisbon",
    longitude: "-9.13552",
    latitude: "38.7072",
  },
  {
    iso3Code: "PRY",
    iso2Code: "PY",
    name: "Paraguay",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: {
      id: "LAC",
      iso2code: "XJ",
      value: "Latin America & Caribbean (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Asuncion",
    longitude: "-57.6362",
    latitude: "-25.3005",
  },
  {
    iso3Code: "PSE",
    iso2Code: "PS",
    name: "West Bank and Gaza",
    // Addresses entered as "Palestine" otherwise fail to match and fall back to the United States
    alternateNames: ["Palestine"],
    region: {
      id: "MEA",
      iso2code: "ZQ",
      value: "Middle East & North Africa",
    },
    adminregion: {
      id: "MNA",
      iso2code: "XQ",
      value: "Middle East & North Africa (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "PSS",
    iso2Code: "S2",
    name: "Pacific island small states",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "PST",
    iso2Code: "V4",
    name: "Post-demographic dividend",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "PYF",
    iso2Code: "PF",
    name: "French Polynesia",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Papeete",
    longitude: "-149.57",
    latitude: "-17.535",
  },
  {
    iso3Code: "QAT",
    iso2Code: "QA",
    name: "Qatar",
    region: {
      id: "MEA",
      iso2code: "ZQ",
      value: "Middle East & North Africa",
    },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Doha",
    longitude: "51.5082",
    latitude: "25.2948",
  },
  {
    iso3Code: "ROU",
    iso2Code: "RO",
    name: "Romania",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Bucharest",
    longitude: "26.0979",
    latitude: "44.4479",
  },
  {
    iso3Code: "RRS",
    iso2Code: "R6",
    name: "Resource rich Sub-Saharan Africa countries",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "RUS",
    iso2Code: "RU",
    name: "Russian Federation",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Moscow",
    longitude: "37.6176",
    latitude: "55.7558",
  },
  {
    iso3Code: "RWA",
    iso2Code: "RW",
    name: "Rwanda",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LIC", iso2code: "XM", value: "Low income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Kigali",
    longitude: "30.0587",
    latitude: "-1.95325",
  },
  {
    iso3Code: "SAS",
    iso2Code: "8S",
    name: "South Asia",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "SAU",
    iso2Code: "SA",
    name: "Saudi Arabia",
    region: {
      id: "MEA",
      iso2code: "ZQ",
      value: "Middle East & North Africa",
    },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Riyadh",
    longitude: "46.6977",
    latitude: "24.6748",
  },
  {
    iso3Code: "SDN",
    iso2Code: "SD",
    name: "Sudan",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LIC", iso2code: "XM", value: "Low income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Khartoum",
    longitude: "32.5363",
    latitude: "15.5932",
  },
  {
    iso3Code: "SEN",
    iso2Code: "SN",
    name: "Senegal",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Dakar",
    longitude: "-17.4734",
    latitude: "14.7247",
  },
  {
    iso3Code: "SGP",
    iso2Code: "SG",
    name: "Singapore",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Singapore",
    longitude: "103.85",
    latitude: "1.28941",
  },
  {
    iso3Code: "SLB",
    iso2Code: "SB",
    name: "Solomon Islands",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: {
      id: "EAP",
      iso2code: "4E",
      value: "East Asia & Pacific (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Honiara",
    longitude: "159.949",
    latitude: "-9.42676",
  },
  {
    iso3Code: "SLE",
    iso2Code: "SL",
    name: "Sierra Leone",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LIC", iso2code: "XM", value: "Low income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Freetown",
    longitude: "-13.2134",
    latitude: "8.4821",
  },
  {
    iso3Code: "SLV",
    iso2Code: "SV",
    name: "El Salvador",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: {
      id: "LAC",
      iso2code: "XJ",
      value: "Latin America & Caribbean (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "San Salvador",
    longitude: "-89.2073",
    latitude: "13.7034",
  },
  {
    iso3Code: "SMR",
    iso2Code: "SM",
    name: "San Marino",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "San Marino",
    longitude: "12.4486",
    latitude: "43.9322",
  },
  {
    iso3Code: "SOM",
    iso2Code: "SO",
    name: "Somalia",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LIC", iso2code: "XM", value: "Low income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Mogadishu",
    longitude: "45.3254",
    latitude: "2.07515",
  },
  {
    iso3Code: "SRB",
    iso2Code: "RS",
    name: "Serbia",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: {
      id: "ECA",
      iso2code: "7E",
      value: "Europe & Central Asia (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Belgrade",
    longitude: "20.4656",
    latitude: "44.8024",
  },
  {
    iso3Code: "SSA",
    iso2Code: "ZF",
    name: "Sub-Saharan Africa (excluding high income)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "SSD",
    iso2Code: "SS",
    name: "South Sudan",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LIC", iso2code: "XM", value: "Low income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Juba",
    longitude: "31.6",
    latitude: "4.85",
  },
  {
    iso3Code: "SSF",
    iso2Code: "ZG",
    name: "Sub-Saharan Africa ",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "SST",
    iso2Code: "S1",
    name: "Small states",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "STP",
    iso2Code: "ST",
    name: "Sao Tome and Principe",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Sao Tome",
    longitude: "6.6071",
    latitude: "0.20618",
  },
  {
    iso3Code: "SUR",
    iso2Code: "SR",
    name: "Suriname",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: {
      id: "LAC",
      iso2code: "XJ",
      value: "Latin America & Caribbean (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IDB", iso2code: "XH", value: "Blend" },
    capitalCity: "Paramaribo",
    longitude: "-55.1679",
    latitude: "5.8232",
  },
  {
    iso3Code: "SVK",
    iso2Code: "SK",
    name: "Slovak Republic",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Bratislava",
    longitude: "17.1073",
    latitude: "48.1484",
  },
  {
    iso3Code: "SVN",
    iso2Code: "SI",
    name: "Slovenia",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Ljubljana",
    longitude: "14.5044",
    latitude: "46.0546",
  },
  {
    iso3Code: "SWE",
    iso2Code: "SE",
    name: "Sweden",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Stockholm",
    longitude: "18.0645",
    latitude: "59.3327",
  },
  {
    iso3Code: "SWZ",
    iso2Code: "SZ",
    name: "Eswatini",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDB", iso2code: "XH", value: "Blend" },
    capitalCity: "Mbabane",
    longitude: "31.4659",
    latitude: "-26.5225",
  },
  {
    iso3Code: "SXM",
    iso2Code: "SX",
    name: "Sint Maarten (Dutch part)",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Philipsburg",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "SXZ",
    iso2Code: "A4",
    name: "Sub-Saharan Africa excluding South Africa",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "SYC",
    iso2Code: "SC",
    name: "Seychelles",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Victoria",
    longitude: "55.4466",
    latitude: "-4.6309",
  },
  {
    iso3Code: "SYR",
    iso2Code: "SY",
    name: "Syrian Arab Republic",
    region: {
      id: "MEA",
      iso2code: "ZQ",
      value: "Middle East & North Africa",
    },
    adminregion: {
      id: "MNA",
      iso2code: "XQ",
      value: "Middle East & North Africa (excluding high income)",
    },
    incomeLevel: { id: "LIC", iso2code: "XM", value: "Low income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Damascus",
    longitude: "36.3119",
    latitude: "33.5146",
  },
  {
    iso3Code: "TCA",
    iso2Code: "TC",
    name: "Turks and Caicos Islands",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Grand Turk",
    longitude: "-71.141389",
    latitude: "21.4602778",
  },
  {
    iso3Code: "TCD",
    iso2Code: "TD",
    name: "Chad",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LIC", iso2code: "XM", value: "Low income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "N'Djamena",
    longitude: "15.0445",
    latitude: "12.1048",
  },
  {
    iso3Code: "TEA",
    iso2Code: "T4",
    name: "East Asia & Pacific (IDA & IBRD countries)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "TEC",
    iso2Code: "T7",
    name: "Europe & Central Asia (IDA & IBRD countries)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "TGO",
    iso2Code: "TG",
    name: "Togo",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LIC", iso2code: "XM", value: "Low income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Lome",
    longitude: "1.2255",
    latitude: "6.1228",
  },
  {
    iso3Code: "THA",
    iso2Code: "TH",
    name: "Thailand",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: {
      id: "EAP",
      iso2code: "4E",
      value: "East Asia & Pacific (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Bangkok",
    longitude: "100.521",
    latitude: "13.7308",
  },
  {
    iso3Code: "TJK",
    iso2Code: "TJ",
    name: "Tajikistan",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: {
      id: "ECA",
      iso2code: "7E",
      value: "Europe & Central Asia (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Dushanbe",
    longitude: "68.7864",
    latitude: "38.5878",
  },
  {
    iso3Code: "TKM",
    iso2Code: "TM",
    name: "Turkmenistan",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: {
      id: "ECA",
      iso2code: "7E",
      value: "Europe & Central Asia (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Ashgabat",
    longitude: "58.3794",
    latitude: "37.9509",
  },
  {
    iso3Code: "TLA",
    iso2Code: "T2",
    name: "Latin America & the Caribbean (IDA & IBRD countries)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "TLS",
    iso2Code: "TL",
    name: "Timor-Leste",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: {
      id: "EAP",
      iso2code: "4E",
      value: "East Asia & Pacific (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDB", iso2code: "XH", value: "Blend" },
    capitalCity: "Dili",
    longitude: "125.567",
    latitude: "-8.56667",
  },
  {
    iso3Code: "TMN",
    iso2Code: "T3",
    name: "Middle East & North Africa (IDA & IBRD countries)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "TON",
    iso2Code: "TO",
    name: "Tonga",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: {
      id: "EAP",
      iso2code: "4E",
      value: "East Asia & Pacific (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Nuku'alofa",
    longitude: "-175.216",
    latitude: "-21.136",
  },
  {
    iso3Code: "TSA",
    iso2Code: "T5",
    name: "South Asia (IDA & IBRD)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "TSS",
    iso2Code: "T6",
    name: "Sub-Saharan Africa (IDA & IBRD countries)",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "TTO",
    iso2Code: "TT",
    name: "Trinidad and Tobago",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Port-of-Spain",
    longitude: "-61.4789",
    latitude: "10.6596",
  },
  {
    iso3Code: "TUN",
    iso2Code: "TN",
    name: "Tunisia",
    region: {
      id: "MEA",
      iso2code: "ZQ",
      value: "Middle East & North Africa",
    },
    adminregion: {
      id: "MNA",
      iso2code: "XQ",
      value: "Middle East & North Africa (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Tunis",
    longitude: "10.21",
    latitude: "36.7899",
  },
  {
    iso3Code: "TUR",
    iso2Code: "TR",
    name: "Turkiye",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: {
      id: "ECA",
      iso2code: "7E",
      value: "Europe & Central Asia (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Ankara",
    longitude: "32.3606",
    latitude: "39.7153",
  },
  {
    iso3Code: "TUV",
    iso2Code: "TV",
    name: "Tuvalu",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: {
      id: "EAP",
      iso2code: "4E",
      value: "East Asia & Pacific (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Funafuti",
    longitude: "179.089567",
    latitude: "-8.6314877",
  },
  {
    iso3Code: "TZA",
    iso2Code: "TZ",
    name: "Tanzania",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Dodoma",
    longitude: "35.7382",
    latitude: "-6.17486",
  },
  {
    iso3Code: "UGA",
    iso2Code: "UG",
    name: "Uganda",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LIC", iso2code: "XM", value: "Low income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Kampala",
    longitude: "32.5729",
    latitude: "0.314269",
  },
  {
    iso3Code: "UKR",
    iso2Code: "UA",
    name: "Ukraine",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: {
      id: "ECA",
      iso2code: "7E",
      value: "Europe & Central Asia (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Kiev",
    longitude: "30.5038",
    latitude: "50.4536",
  },
  {
    iso3Code: "UMC",
    iso2Code: "XT",
    name: "Upper middle income",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "URY",
    iso2Code: "UY",
    name: "Uruguay",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Montevideo",
    longitude: "-56.0675",
    latitude: "-34.8941",
  },
  unitedStatesWorldBankCountry,
  {
    iso3Code: "UZB",
    iso2Code: "UZ",
    name: "Uzbekistan",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: {
      id: "ECA",
      iso2code: "7E",
      value: "Europe & Central Asia (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDB", iso2code: "XH", value: "Blend" },
    capitalCity: "Tashkent",
    longitude: "69.269",
    latitude: "41.3052",
  },
  {
    iso3Code: "VCT",
    iso2Code: "VC",
    name: "St. Vincent and the Grenadines",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: {
      id: "LAC",
      iso2code: "XJ",
      value: "Latin America & Caribbean (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IDB", iso2code: "XH", value: "Blend" },
    capitalCity: "Kingstown",
    longitude: "-61.2653",
    latitude: "13.2035",
  },
  {
    iso3Code: "VEN",
    iso2Code: "VE",
    name: "Venezuela, RB",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "INX", iso2code: "XY", value: "Not classified" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Caracas",
    longitude: "-69.8371",
    latitude: "9.08165",
  },
  {
    iso3Code: "VGB",
    iso2Code: "VG",
    name: "British Virgin Islands",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Road Town",
    longitude: "-64.623056",
    latitude: "18.431389",
  },
  {
    iso3Code: "VIR",
    iso2Code: "VI",
    name: "Virgin Islands (U.S.)",
    region: {
      id: "LCN",
      iso2code: "ZJ",
      value: "Latin America & Caribbean ",
    },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "HIC", iso2code: "XD", value: "High income" },
    lendingType: { id: "LNX", iso2code: "XX", value: "Not classified" },
    capitalCity: "Charlotte Amalie",
    longitude: "-64.8963",
    latitude: "18.3358",
  },
  {
    iso3Code: "VNM",
    iso2Code: "VN",
    name: "Viet Nam",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: {
      id: "EAP",
      iso2code: "4E",
      value: "East Asia & Pacific (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Hanoi",
    longitude: "105.825",
    latitude: "21.0069",
  },
  {
    iso3Code: "VUT",
    iso2Code: "VU",
    name: "Vanuatu",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: {
      id: "EAP",
      iso2code: "4E",
      value: "East Asia & Pacific (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Port-Vila",
    longitude: "168.321",
    latitude: "-17.7404",
  },
  {
    iso3Code: "WLD",
    iso2Code: "1W",
    name: "World",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "WSM",
    iso2Code: "WS",
    name: "Samoa",
    region: { id: "EAS", iso2code: "Z4", value: "East Asia & Pacific" },
    adminregion: {
      id: "EAP",
      iso2code: "4E",
      value: "East Asia & Pacific (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Apia",
    longitude: "-171.752",
    latitude: "-13.8314",
  },
  {
    iso3Code: "XKX",
    iso2Code: "XK",
    name: "Kosovo",
    region: { id: "ECS", iso2code: "Z7", value: "Europe & Central Asia" },
    adminregion: {
      id: "ECA",
      iso2code: "7E",
      value: "Europe & Central Asia (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Pristina",
    longitude: "20.926",
    latitude: "42.565",
  },
  {
    iso3Code: "XZN",
    iso2Code: "A5",
    name: "Sub-Saharan Africa excluding South Africa and Nigeria",
    region: { id: "NA", iso2code: "NA", value: "Aggregates" },
    adminregion: { id: "", iso2code: "", value: "" },
    incomeLevel: { id: "NA", iso2code: "NA", value: "Aggregates" },
    lendingType: { id: "", iso2code: "", value: "Aggregates" },
    capitalCity: "",
    longitude: "",
    latitude: "",
  },
  {
    iso3Code: "YEM",
    iso2Code: "YE",
    name: "Yemen, Rep.",
    region: {
      id: "MEA",
      iso2code: "ZQ",
      value: "Middle East & North Africa",
    },
    adminregion: {
      id: "MNA",
      iso2code: "XQ",
      value: "Middle East & North Africa (excluding high income)",
    },
    incomeLevel: { id: "LIC", iso2code: "XM", value: "Low income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Sana'a",
    longitude: "44.2075",
    latitude: "15.352",
  },
  {
    iso3Code: "ZAF",
    iso2Code: "ZA",
    name: "South Africa",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "UMC", iso2code: "XT", value: "Upper middle income" },
    lendingType: { id: "IBD", iso2code: "XF", value: "IBRD" },
    capitalCity: "Pretoria",
    longitude: "28.1871",
    latitude: "-25.746",
  },
  {
    iso3Code: "ZMB",
    iso2Code: "ZM",
    name: "Zambia",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDX", iso2code: "XI", value: "IDA" },
    capitalCity: "Lusaka",
    longitude: "28.2937",
    latitude: "-15.3982",
  },
  {
    iso3Code: "ZWE",
    iso2Code: "ZW",
    name: "Zimbabwe",
    region: { id: "SSF", iso2code: "ZG", value: "Sub-Saharan Africa " },
    adminregion: {
      id: "SSA",
      iso2code: "ZF",
      value: "Sub-Saharan Africa (excluding high income)",
    },
    incomeLevel: { id: "LMC", iso2code: "XN", value: "Lower middle income" },
    lendingType: { id: "IDB", iso2code: "XH", value: "Blend" },
    capitalCity: "Harare",
    longitude: "31.0672",
    latitude: "-17.8312",
  },
];
